import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  OnDestroy,
  SimpleChanges,
  OnChanges,
  inject,
} from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { IconType } from '../../models/settings.model';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false,
})
export class ModalComponent implements OnInit, OnChanges, OnDestroy {
  defaultCssStyles: object = {
    wrapper: '',
  };

  @Input() cssStyles: any;
  @Input() type?: IconType;
  @Input() title: any;
  @Input() id: any;
  @Input() open: boolean = false;
  @Input() showCrossCloseBtn: boolean = true;
  @Output() crossClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() outsideClick: EventEmitter<void> = new EventEmitter<void>();

  private clickSubscription!: Subscription;
  private readonly modalElement: ElementRef = inject(ElementRef);

  ngOnInit(): void {
    this.cssStyles = { ...this.defaultCssStyles, ...this.cssStyles };
  }

  ngOnDestroy(): void {
    this.unsubscribeClick();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['open']) {
      if (changes['open'].currentValue) {
        this.subscribeClick();
      } else {
        this.unsubscribeClick();
      }
    }
  }

  /**
   * Hides the modal and emits the crossClick event.
   */
  hideModal(): void {
    this.open = false;
    this.crossClick.emit();
    this.unsubscribeClick();
  }

  /**
   * Subscribes to click events to detect clicks outside the modal.
   * @private
   */
  private subscribeClick(): void {
    // Delay the subscription via zero timeout function to avoid immediate closure.
    setTimeout(() => {
      this.clickSubscription = fromEvent(document, 'click')
        .pipe(
          filter((event: Event) => {
            const container: Element | null = this.modalElement.nativeElement.querySelector('.modal-dialog__container');
            return this.open && !!container && !container.contains(event.target as Node);
          })        )
        .subscribe(() => {
          this.open = false;
          this.outsideClick.emit();
          this.unsubscribeClick();
        });
    });
  }

  /**
   * Unsubscribes from click events.
   * @private
   */
  private unsubscribeClick(): void {
    if (this.clickSubscription) {
      this.clickSubscription.unsubscribe();
      this.clickSubscription = undefined!;
    }
  }
}
